module.exports = __webpack_public_path__ + "4eb103b4d12be57cb1d040ed5e162e9d.woff2";


//////////////////
// WEBPACK FOOTER
// ./assets/Lato-Italic.woff2
// module id = 969
// module chunks = 0